/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from "@angular/core";
import { Annotation, AnnotationSettingsTagTextLabel, TagsState } from "../../../../../feature/src/lib/models/annotation-settings";
import { GlobalConstants } from "../../../../../feature/src/lib/constants/global-constants";

@Injectable({
    providedIn: 'root'
})

export class AnnotationSettingsLabelsManager {

    //latest values cable tray size
    static ctSize1XLocation: number;
    static ctSize1YLocation: number;
    static ctSize1Angle: number;

    static ctSize2XLocation: number;
    static ctSize2YLocation: number;
    static ctSize2Angle: number;

    static ctSize3XLocation: number;
    static ctSize3YLocation: number;
    static ctSize3Angle: number;

    static ctSize4XLocation: number;
    static ctSize4YLocation: number;
    static ctSize4Angle: number;

    //latest values cable tray elevation
    static ctElevation1XLocation: number;
    static ctElevation1YLocation: number;
    static ctElevation1Angle: number;

    static ctElevation2XLocation: number;
    static ctElevation2YLocation: number;
    static ctElevation2Angle: number;

    //latest values cable tray item number
    static ctItemNumber1XLocation: number;
    static ctItemNumber1YLocation: number;
    static ctItemNumber1Angle: number;

    static ctItemNumber2XLocation: number;
    static ctItemNumber2YLocation: number;
    static ctItemNumber2Angle: number;

    static ctItemNumber3XLocation: number;
    static ctItemNumber3YLocation: number;
    static ctItemNumber3Angle: number;

    //latest values cable tray spool
    static ctSpool1XLocation: number;
    static ctSpool1YLocation: number;
    static ctSpool1Angle: number;

    static ctSpool2XLocation: number;
    static ctSpool2YLocation: number;
    static ctSpool2Angle: number;

    static ctSpool3XLocation: number;
    static ctSpool3YLocation: number;
    static ctSpool3Angle: number;

    //latest values conduit settings size
    static csSize1XLocation: number;
    static csSize1YLocation: number;
    static csSize1Angle: number;

    static csSize2XLocation: number;
    static csSize2YLocation: number;
    static csSize2Angle: number;

    static csSize3XLocation: number;
    static csSize3YLocation: number;
    static csSize3Angle: number;

    static csSize4XLocation: number;
    static csSize4YLocation: number;
    static csSize4Angle: number;

    //latest values conduit settings elevation
    static csElevation1XLocation: number;
    static csElevation1YLocation: number;
    static csElevation1Angle: number;

    static csElevation2XLocation: number;
    static csElevation2YLocation: number;
    static csElevation2Angle: number;

    //latest values conduit settings item number
    static csItemNumber1XLocation: number;
    static csItemNumber1YLocation: number;
    static csItemNumber1Angle: number;

    static csItemNumber2XLocation: number;
    static csItemNumber2YLocation: number;
    static csItemNumber2Angle: number;

    static csItemNumber3XLocation: number;
    static csItemNumber3YLocation: number;
    static csItemNumber3Angle: number;

    //latest values conduit settings spool
    static csSpool1XLocation: number;
    static csSpool1YLocation: number;
    static csSpool1Angle: number;

    static csSpool2XLocation: number;
    static csSpool2YLocation: number;
    static csSpool2Angle: number;

    static csSpool3XLocation: number;
    static csSpool3YLocation: number;
    static csSpool3Angle: number;

    loadImageByTabAndState(tabName: string, tagState: TagsState, data: Annotation[]) {
        var canvas: HTMLCanvasElement = this.getCanvasByTabName(tabName);
        var context= canvas.getContext('2d') as CanvasRenderingContext2D;
        var image = this.setImageByTabName(tabName, tagState);

        image.onload = function () {
            onLoadImage(context, canvas, image, tabName, tagState, data);
        }
    }

    private getCanvasByTabName(tabName: string): HTMLCanvasElement {
      const canvas = tabName === GlobalConstants.CABLE_TRAY_TAB_NAME ?
          <HTMLCanvasElement>document.getElementById('cable-tray-canvas') :
          <HTMLCanvasElement>document.getElementById('conduit-settings-canvas');
      canvas.width = 640;
      canvas.height = 365;
      return canvas;
  }

    private setImageByTabName(tabName: string, tagState: TagsState) {
        const image = new Image();
        if (tagState.spoolTag === true) {
            image.src = tabName === GlobalConstants.CABLE_TRAY_TAB_NAME ? 'assets/img/CableTraySpool.jpg' : 'assets/img/ConduitSpool.jpg';
        } else {
            image.src = tabName === GlobalConstants.CABLE_TRAY_TAB_NAME ? 'assets/img/CableTray.jpg' : 'assets/img/Conduit.jpg';
        }
        return image;
    }
}

export function onLoadImage(context: CanvasRenderingContext2D, canvas : HTMLCanvasElement, image: HTMLImageElement, tabName: string, tagState: TagsState, data: Annotation[])
{
    if (!context) {
        return;
    }
    // clear the canvas
    context.clearRect(0, 0, canvas.width, canvas.height);

    //load labels based on tag names
    switch (tabName) {
        case GlobalConstants.CABLE_TRAY_TAB_NAME:
            context.drawImage(image, 20, 20, canvas.width - (2 * 20), canvas.height - (2 * 20));
            loadCableTrayLabels(context, tagState, data);
            break;
        case GlobalConstants.CONDUIT_SETTINGS_TAB_NAME:
            context.drawImage(image, 0, 0, canvas.width, canvas.height);
            loadConduitSettingsLabels(context, tagState, data);
            break;
        default:
            break;
    }
}

// Add text to the canvas
export function addText(context: CanvasRenderingContext2D, tagLabel: AnnotationSettingsTagTextLabel) {
    context.save();
    context.translate(tagLabel.xLocation, tagLabel.yLocation); // Move to the position where text will be drawn
    context.rotate(tagLabel.angle * Math.PI / 180); // Rotate by angle degrees
    context.font = '12px Segoe UI Variable';
    context.fillStyle = 'blue'; // Text color
    context.fillText(tagLabel.labelName, 0, 0); // Draw the text
    context.restore();
}

//#region Cable Tray Labels
// Load cable tray labels based on tag names
export function loadCableTrayLabels(context: CanvasRenderingContext2D, tagState: TagsState, data: Annotation[]) {
    if (!context || !tagState) {
        return;
    }
    const image = new Image();
    if (tagState.sizeTag === true) {
        image.src = 'assets/img/CableTray.jpg';
        loadCableTraySizeLabels(context, data.filter(x => x.annotationName === GlobalConstants.SIZE_ANNOTATION_NAME));
    }
    if (tagState.elevationTag === true) {
        loadCableTrayElevationLabels(context, data.filter(x => x.annotationName === GlobalConstants.ELEVATION_ANNOTATION_NAME));
    }
    if (tagState.itemNumberTag === true) {
        loadCableTrayItemNumberLabels(context, data.filter(x => x.annotationName === GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME));
    }
    if (tagState.spoolTag === true) {
        loadCableTraySpoolLabels(context, data.filter(x => x.annotationName === GlobalConstants.SPOOL_ANNOTATION_NAME));
    }
}

function addLabels(context: CanvasRenderingContext2D, textLabel: string, labels: { x: number, y: number, angle: number }[]): void {
    labels.forEach(label => {
        addText(context, new AnnotationSettingsTagTextLabel(textLabel, label.x, label.y, label.angle));
    });
}

function updateLabelPositions(xOffset: string, yOffset: string, labels: { x: number, y: number, angle: number }[]): void {
    labels.forEach(label => {
        if (label.angle === 270) {
            label.x += parseInt(yOffset);
            label.y -= parseInt(xOffset);

        } else {
            label.x += parseInt(xOffset);
            label.y += parseInt(yOffset);
        }
    });
}

function saveLatestValues(prefix: string, labels: { x: number, y: number, angle: number }[]) {
    for (let i = 0; i < labels.length; i++) {
        (AnnotationSettingsLabelsManager as any)[`${prefix}${i + 1}XLocation`] = labels[i].x;
        (AnnotationSettingsLabelsManager as any)[`${prefix}${i + 1}YLocation`] = labels[i].y;
        (AnnotationSettingsLabelsManager as any)[`${prefix}${i + 1}Angle`] = labels[i].angle;
    }
}

//#region cable tray size labels
function loadCableTraySizeLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.SIZE_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.ctSize1XLocation, y: AnnotationSettingsLabelsManager.ctSize1YLocation, angle: AnnotationSettingsLabelsManager.ctSize1Angle },
            { x: AnnotationSettingsLabelsManager.ctSize2XLocation, y: AnnotationSettingsLabelsManager.ctSize2YLocation, angle: AnnotationSettingsLabelsManager.ctSize2Angle },
            { x: AnnotationSettingsLabelsManager.ctSize3XLocation, y: AnnotationSettingsLabelsManager.ctSize3YLocation, angle: AnnotationSettingsLabelsManager.ctSize3Angle },
            { x: AnnotationSettingsLabelsManager.ctSize4XLocation, y: AnnotationSettingsLabelsManager.ctSize4YLocation, angle: AnnotationSettingsLabelsManager.ctSize4Angle }
        ]);
        return;
    }

    const occurrence = data[0].option;
    const placement = data[0].location;
    let sizes: { x: number, y: number, angle: number }[] = [];

    switch (occurrence) {
        case GlobalConstants.SIZE_CHANGE:
            switch (placement) {
                case GlobalConstants.ABOVE:
                    sizes = [
                        { x: 374, y: 20, angle: 0 },
                        { x: 432, y: 24, angle: 0 },
                        // big values becasue we don't want to show these labels
                        { x: 1000, y: 1000, angle: 0 },
                        { x: 1000, y: 1000, angle: 0 }
                    ];
                    break;
                case GlobalConstants.CENTER:
                    sizes = [
                        { x: 374, y: 40, angle: 0 },
                        { x: 432, y: 40, angle: 0 },
                         // big values becasue we don't want to show these labels
                        { x: 1000, y: 1000, angle: 0 },
                        { x: 1000, y: 1000, angle: 0 }
                    ];
                    break;
                case GlobalConstants.BELOW:
                    sizes = [
                        { x: 374, y: 58, angle: 0 },
                        { x: 432, y: 54, angle: 0 },
                         // big values becasue we don't want to show these labels
                        { x: 1000, y: 1000, angle: 0 },
                        { x: 1000, y: 1000, angle: 0 }
                    ];
                    break;
                default:
                    break;
            }
            break;
        case GlobalConstants.DIRECTION:
            switch (placement) {
                case GlobalConstants.ABOVE:
                    sizes = [
                        { x: 136, y: 308, angle: 0 },
                        { x: 216, y: 240, angle: 270 },
                        { x: 374, y: 20, angle: 0 },
                        { x: 432, y: 24, angle: 0 }
                    ];
                    break;
                case GlobalConstants.CENTER:
                    sizes = [
                        { x: 136, y: 325, angle: 0 },
                        { x: 234, y: 240, angle: 270 },
                        { x: 374, y: 40, angle: 0 },
                        { x: 432, y: 40, angle: 0 }
                    ];
                    break;
                case GlobalConstants.BELOW:
                    sizes = [
                        { x: 136, y: 345, angle: 0 },
                        { x: 248, y: 240, angle: 270 },
                        { x: 374, y: 58, angle: 0 },
                        { x: 432, y: 54, angle: 0 }
                    ];
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, sizes);
    saveLatestValues('ctSize', sizes);
    addLabels(context, GlobalConstants.SIZE_ANNOTATION_NAME, sizes);
}
//#endregion

//#region cable tray elevation labels
function loadCableTrayElevationLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.ELEVATION_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.ctElevation1XLocation, y: AnnotationSettingsLabelsManager.ctElevation1YLocation, angle: AnnotationSettingsLabelsManager.ctElevation1Angle },
            { x: AnnotationSettingsLabelsManager.ctElevation2XLocation, y: AnnotationSettingsLabelsManager.ctElevation2YLocation, angle: AnnotationSettingsLabelsManager.ctElevation2Angle }
        ]);
        return;
    }

    const occurrence = data[0].option;
    const placement = data[0].location;
    let elevations: { x: number, y: number, angle: number }[] = [];

    switch (occurrence) {
        case GlobalConstants.ELEVATION_CHANGE:
        case GlobalConstants.DIRECTION:
            switch (placement) {
                case GlobalConstants.ABOVE:
                    elevations = [
                        { x: 218, y: 286, angle: 270 },
                        { x: 218, y: 228, angle: 270 }
                    ];
                    break;
                case GlobalConstants.CENTER:
                    elevations = [
                        { x: 235, y: 286, angle: 270 },
                        { x: 235, y: 228, angle: 270 }
                    ];
                    break;
                case GlobalConstants.BELOW:
                    elevations = [
                        { x: 250, y: 286, angle: 270 },
                        { x: 250, y: 228, angle: 270 }
                    ];
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, elevations);
    saveLatestValues('ctElevation', elevations);
    addLabels(context, GlobalConstants.ELEVATION_ANNOTATION_NAME, elevations);
}
//#endregion

//#region cable tray item number labels
function loadCableTrayItemNumberLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.ctItemNumber1XLocation, y: AnnotationSettingsLabelsManager.ctItemNumber1YLocation, angle: AnnotationSettingsLabelsManager.ctItemNumber1Angle },
            { x: AnnotationSettingsLabelsManager.ctItemNumber2XLocation, y: AnnotationSettingsLabelsManager.ctItemNumber2YLocation, angle: AnnotationSettingsLabelsManager.ctItemNumber2Angle },
            { x: AnnotationSettingsLabelsManager.ctItemNumber3XLocation, y: AnnotationSettingsLabelsManager.ctItemNumber3YLocation, angle: AnnotationSettingsLabelsManager.ctItemNumber3Angle }
        ]);
        return;
    }

    const placement = data[0].location;
    let itemNumbers: { x: number, y: number, angle: number }[] = [];

    switch (placement) {
        case GlobalConstants.ABOVE:
            itemNumbers = [
                { x: 220, y: 63, angle: 270 },
                { x: 312, y: 22, angle: 0 },
                { x: 512, y: 28, angle: 0 }
            ];
            break;
        case GlobalConstants.CENTER:
            itemNumbers = [
                { x: 235, y: 63, angle: 270 },
                { x: 312, y: 38, angle: 0 },
                { x: 512, y: 38, angle: 0 }
            ];
            break;
        case GlobalConstants.BELOW:
            itemNumbers = [
                { x: 250, y: 63, angle: 270 },
                { x: 312, y: 58, angle: 0 },
                { x: 512, y: 53, angle: 0 }
            ];
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, itemNumbers);
    saveLatestValues('ctItemNumber', itemNumbers);
    addLabels(context, GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME, itemNumbers);
}
//#endregion

//#region cable tray spool labels
function loadCableTraySpoolLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.SPOOL_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.ctSpool1XLocation, y: AnnotationSettingsLabelsManager.ctSpool1YLocation, angle: AnnotationSettingsLabelsManager.ctSpool1Angle },
            { x: AnnotationSettingsLabelsManager.ctSpool2XLocation, y: AnnotationSettingsLabelsManager.ctSpool2YLocation, angle: AnnotationSettingsLabelsManager.ctSpool2Angle },
            { x: AnnotationSettingsLabelsManager.ctSpool3XLocation, y: AnnotationSettingsLabelsManager.ctSpool3YLocation, angle: AnnotationSettingsLabelsManager.ctSpool3Angle }
        ]);
        return;
    }

    const placement = data[0].location;
    let spools: { x: number, y: number, angle: number }[] = [];
    switch (placement) {
        case GlobalConstants.ABOVE:
            spools = [
                { x: 75, y: 307, angle: 0 },
                { x: 215, y: 170, angle: 270 },
                { x: 405, y: 20, angle: 0 }
            ];
            break;
        case GlobalConstants.CENTER:
            spools = [
                { x: 75, y: 325, angle: 0 },
                { x: 233, y: 170, angle: 270 },
                { x: 405, y: 39, angle: 0 }
            ];
            break;
        case GlobalConstants.BELOW:
            spools = [
                { x: 75, y: 343, angle: 0 },
                { x: 252, y: 170, angle: 270 },
                { x: 405, y: 59, angle: 0 }
            ];
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, spools);
    saveLatestValues('ctSpool', spools);
    addLabels(context, GlobalConstants.SPOOL_ANNOTATION_NAME, spools);
}
//#endregion
//#endregion

//#region Conduit Settings Labels
// Load conduit settings labels based on tag names
export function loadConduitSettingsLabels(context: CanvasRenderingContext2D, tagState: TagsState, data: Annotation[]) {
    if (!context || !tagState) {
        return;
    }
    if (tagState.sizeTag === true) {
        loadConduitSettingsSizeLabels(context, data.filter(x => x.annotationName === GlobalConstants.SIZE_ANNOTATION_NAME));
    }
    if (tagState.elevationTag === true) {
        loadConduitSettingsElevationLabels(context, data.filter(x => x.annotationName === GlobalConstants.ELEVATION_ANNOTATION_NAME));
    }
    if (tagState.itemNumberTag === true) {
        loadConduitSettingsItemNumberLabels(context, data.filter(x => x.annotationName === GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME));
    }
    if (tagState.spoolTag === true) {
        loadConduitSettingsSpoolLabels(context, data.filter(x => x.annotationName === GlobalConstants.SPOOL_ANNOTATION_NAME));
    }
}

//#region conduit settings size labels
function loadConduitSettingsSizeLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.SIZE_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.csSize1XLocation, y: AnnotationSettingsLabelsManager.csSize1YLocation, angle: AnnotationSettingsLabelsManager.csSize1Angle },
            { x: AnnotationSettingsLabelsManager.csSize2XLocation, y: AnnotationSettingsLabelsManager.csSize2YLocation, angle: AnnotationSettingsLabelsManager.csSize2Angle },
            { x: AnnotationSettingsLabelsManager.csSize3XLocation, y: AnnotationSettingsLabelsManager.csSize3YLocation, angle: AnnotationSettingsLabelsManager.csSize3Angle },
            { x: AnnotationSettingsLabelsManager.csSize4XLocation, y: AnnotationSettingsLabelsManager.csSize4YLocation, angle: AnnotationSettingsLabelsManager.csSize4Angle }
        ]);
        return;
    }

    const occurrence = data[0].option;
    const placement = data[0].location;
    let sizes: { x: number, y: number, angle: number }[] = [];

    switch (occurrence) {
        case GlobalConstants.SIZE_CHANGE:
            switch (placement) {
                case GlobalConstants.ABOVE:
                    sizes = [
                        { x: 391, y: 27, angle: 0 },
                        { x: 480, y: 30, angle: 0 },
                        // big values becasue we don't want to show these labels
                        { x: 1000, y: 1000, angle: 0 },
                        { x: 1000, y: 1000, angle: 0 }
                    ];
                    break;
                case GlobalConstants.CENTER:
                    sizes = [
                        { x: 391, y: 40, angle: 0 },
                        { x: 480, y: 40, angle: 0 },
                         // big values becasue we don't want to show these labels
                        { x: 1000, y: 1000, angle: 0 },
                        { x: 1000, y: 1000, angle: 0 }
                    ];
                    break;
                case GlobalConstants.BELOW:
                    sizes = [
                        { x: 391, y: 55, angle: 0 },
                        { x: 480, y: 53, angle: 0 },
                         // big values becasue we don't want to show these labels
                        { x: 1000, y: 1000, angle: 0 },
                        { x: 1000, y: 1000, angle: 0 }
                    ];
                    break;
                default:
                    break;
            }
            break;
        case GlobalConstants.DIRECTION:
            switch (placement) {
                case GlobalConstants.ABOVE:
                    sizes = [
                        { x: 117, y: 333, angle: 0 },
                        { x: 277, y: 285, angle: 270 },
                        { x: 342, y: 27, angle: 0 },
                        { x: 557, y: 30, angle: 0 }
                    ];
                    break;
                case GlobalConstants.CENTER:
                    sizes = [
                        { x: 117, y: 347, angle: 0 },
                        { x: 292, y: 285, angle: 270 },
                        { x: 342, y: 40, angle: 0 },
                        { x: 557, y: 40, angle: 0 }
                    ];
                    break;
                case GlobalConstants.BELOW:
                    sizes = [
                        { x: 117, y: 360, angle: 0 },
                        { x: 305, y: 285, angle: 270 },
                        { x: 342, y: 55, angle: 0 },
                        { x: 557, y: 53, angle: 0 }
                    ];
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, sizes);
    saveLatestValues('csSize', sizes);
    addLabels(context, GlobalConstants.SIZE_ANNOTATION_NAME, sizes);
}
//#endregion

//#region conduit settings elevation labels
function loadConduitSettingsElevationLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.ELEVATION_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.csElevation1XLocation, y: AnnotationSettingsLabelsManager.csElevation1YLocation, angle: AnnotationSettingsLabelsManager.csElevation1Angle },
            { x: AnnotationSettingsLabelsManager.csElevation2XLocation, y: AnnotationSettingsLabelsManager.csElevation2YLocation, angle: AnnotationSettingsLabelsManager.csElevation2Angle }
        ]);
        return;
    }

    const occurrence = data[0].option;
    const placement = data[0].location;
    let elevations: { x: number, y: number, angle: number }[] = [];

    switch (occurrence) {
        case GlobalConstants.ELEVATION_CHANGE:
        case GlobalConstants.DIRECTION:
            switch (placement) {
                case GlobalConstants.ABOVE:
                    elevations = [
                        { x: 278, y: 283, angle: 270 },
                        { x: 278, y: 204, angle: 270 }
                    ];
                    break;
                case GlobalConstants.CENTER:
                    elevations = [
                        { x: 291, y: 283, angle: 270 },
                        { x: 291, y: 204, angle: 270 }
                    ];
                    break;
                case GlobalConstants.BELOW:
                    elevations = [
                        { x: 305, y: 283, angle: 270 },
                        { x: 305, y: 204, angle: 270 }
                    ];
                    break;
                default:
                    break;
            }
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, elevations);
    saveLatestValues('csElevation', elevations);
    addLabels(context, GlobalConstants.ELEVATION_ANNOTATION_NAME, elevations);
}
//#endregion

//#region conduit settings item number labels
function loadConduitSettingsItemNumberLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.csItemNumber1XLocation, y: AnnotationSettingsLabelsManager.csItemNumber1YLocation, angle: AnnotationSettingsLabelsManager.csItemNumber1Angle },
            { x: AnnotationSettingsLabelsManager.csItemNumber2XLocation, y: AnnotationSettingsLabelsManager.csItemNumber2YLocation, angle: AnnotationSettingsLabelsManager.csItemNumber2Angle },
            { x: AnnotationSettingsLabelsManager.csItemNumber3XLocation, y: AnnotationSettingsLabelsManager.csItemNumber3YLocation, angle: AnnotationSettingsLabelsManager.csItemNumber3Angle }
        ]);
        return;
    }

    const placement = data[0].location;
    let itemNumbers: { x: number, y: number, angle: number }[] = [];

    switch (placement) {
        case GlobalConstants.ABOVE:
            itemNumbers = [
                { x: 276, y: 70, angle: 270 },
                { x: 350, y: 27, angle: 0 },
                { x: 530, y: 29, angle: 0 }
            ];
            break;
        case GlobalConstants.CENTER:
            itemNumbers = [
                { x: 296, y: 70, angle: 270 },
                { x: 350, y: 39, angle: 0 },
                { x: 530, y: 39, angle: 0 }
            ];
            break;
        case GlobalConstants.BELOW:
            itemNumbers = [
                { x: 314, y: 70, angle: 270 },
                { x: 350, y: 55, angle: 0 },
                { x: 530, y: 53, angle: 0 }
            ];
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, itemNumbers);
    saveLatestValues('csItemNumber', itemNumbers);
    addLabels(context, GlobalConstants.ITEM_NUMBER_ANNOTATION_NAME, itemNumbers);
}
//#endregion

//#region conduit settings spool labels
function loadConduitSettingsSpoolLabels(context: CanvasRenderingContext2D, data: Annotation[]) {
    if (!context) {
        return;
    }

    if (data.length === 0) {
        // Default positions
        addLabels(context, GlobalConstants.SPOOL_ANNOTATION_NAME, [
            { x: AnnotationSettingsLabelsManager.csSpool1XLocation, y: AnnotationSettingsLabelsManager.csSpool1YLocation, angle: AnnotationSettingsLabelsManager.csSpool1Angle },
            { x: AnnotationSettingsLabelsManager.csSpool2XLocation, y: AnnotationSettingsLabelsManager.csSpool2YLocation, angle: AnnotationSettingsLabelsManager.csSpool2Angle },
            { x: AnnotationSettingsLabelsManager.csSpool3XLocation, y: AnnotationSettingsLabelsManager.csSpool3YLocation, angle: AnnotationSettingsLabelsManager.csSpool3Angle }
        ]);
        return;
    }

    const placement = data[0].location;
    let spools: { x: number, y: number, angle: number }[] = [];
    switch (placement) {
        case GlobalConstants.ABOVE:
            spools = [
                { x: 68, y: 332, angle: 0 },
                { x: 278, y: 250, angle: 270 },
                { x: 499, y: 31, angle: 0 }
            ];
            break;
        case GlobalConstants.CENTER:
            spools = [
                { x: 68, y: 347, angle: 0 },
                { x: 291, y: 250, angle: 270 },
                { x: 499, y: 40, angle: 0 }
            ];
            break;
        case GlobalConstants.BELOW:
            spools = [
                { x: 68, y: 360, angle: 0 },
                { x: 305, y: 250, angle: 270 },
                { x: 499, y: 53, angle: 0 }
            ];
            break;
        default:
            break;
    }

    const xOffset = data[0].xOffset;
    const yOffset = data[0].yOffset;
    updateLabelPositions(xOffset, yOffset, spools);
    saveLatestValues('csSpool', spools);
    addLabels(context, GlobalConstants.SPOOL_ANNOTATION_NAME, spools);
}
//#endregion
//#endregion